import { LoginRequestBody } from "../../../hooks/api/Login/interfaces/login.request";
import { LoginFormInputs } from "../interfaces/LoginFormInputs";

export const makeRequestBody = (obj: LoginFormInputs): LoginRequestBody => {
  return {
    phone: obj.username,
    password: obj.password,
  };
};
